<template>
    <div class="m_header">
        <i v-if="showLeft" class="iconfont icon-jiantou-copy" @click="back" />
        <p>{{ title }}</p>
        <i v-if="showRight" class="iconfont icon-jiantou" />
    </div>
</template>

<script>
const defaultSettings = require('../../settings')
const name = defaultSettings.title
import { mapGetters } from 'vuex'
import { getTid, getSid } from '@/utils/cookies'

export default {
    name: 'Header',
    props: {
        title: {
            type: String,
            default: name
        },
        showLeft: {
            type: Boolean,
            default: false
        },
        showRight: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            root: '',
            tid: this.$route.query.tid ? this.$route.query.tid : '',
            sid: this.$route.query.sid ? this.$route.query.sid : ''
        }
    },

    computed: {
        ...mapGetters(['tougaoSetting', 'examInfo'])
    },
    mounted() {
        this.root = document.querySelector(':root')
        this.setColor()
    },

    methods: {
        back() {
            this.$router.go(-1)// 返回上一层
        },
        setColor() {
            if (getTid()) {
                const { main_color, menus_color } = this.tougaoSetting
                this.root.style.setProperty('--color', menus_color) // 菜单按钮颜色
                this.root.style.setProperty('--bck', main_color) // 主色调
            }
            if (getSid()) {
                const { main_color, menus_color } = this.examInfo
                this.root.style.setProperty('--color', menus_color) // 菜单按钮颜色
                this.root.style.setProperty('--bck', main_color) // 主色调
            }
        }
    }
}
</script>

<style lang="less" scoped>
.m_header{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 44px;
  line-height: 44px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  background: var(--bck);
  font-size: 18px;
  color: #fff;
  z-index: 99;

  p{
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 44px;
    white-space: nowrap;
  }

  .logout{
    font-size: 18px;
    display:inline-block;
    padding-left:4px;
  }
}
</style>
